function animateValue(obj, start, end, duration) {

    if (obj._isAnimated) return; // Animate only once!
    obj._isAnimated = true;

    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = Math.floor(progress * (end - start) + start).toLocaleString(undefined, {minimumFractionDigits: 0});
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

jQuery(window).on('load', function() {
    activateCounters();
    initSlickCarousel();
    initListeners();
    if (window.location.hash) {
        scrollTo(window.location.hash);
    }

    // Check visibility of second page of application form
    let $page = document.getElementById('gform_page_2_2');
    if ($page) {
        if ($page.checkVisibility()) {
            if (jQuery('#input_2_36').val() === 'Denied') {
                jQuery('#gform_page_2_2').prepend('<div id="case-status" class="gfield--type-html"></div>');
                jQuery('#case-status').append('<h2>' + jQuery('#input_2_36').val() + '</h2>');
                jQuery('#case-status').append(jQuery('#input_2_37').val());
            }
        }
    }
});

function handleMegaNavClick(event) {
    const clickedColumn = event.target.closest('li');
    document.querySelectorAll(".mega-navigation .menu-main-container > ul > li > ul").forEach(column => {
        if (column !== clickedColumn) {
            column.classList.remove("in");
        }
    });
    clickedColumn.classList.toggle("in");
    if (( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) || (window.innerWidth < 768)) {
        event.preventDefault();
    }
}

function initListeners() {
    document.querySelector('#menu-main').addEventListener('mouseenter', function() {
        const megaNav = document.querySelector('.mega-navigation');
        if (window.innerWidth > 1199) {
            megaNav.classList.add('open');
        }
        else {
            megaNav.classList.remove('open');
        }
    });

    document.querySelector('.mega-navigation').addEventListener('mouseleave', function() {
        const megaNav = document.querySelector('.mega-navigation');
        megaNav.classList.remove('open');
    });

    // Mobile nav listeners
    if (window.innerWidth < 768) {
        document.querySelectorAll(".mega-navigation .menu-main-container > ul > li:not(.btn) > a").forEach(heading => {
            heading.addEventListener("click", handleMegaNavClick);
        });
    }

    // Gravity Form listeners
    let $paymentAssistance = jQuery("input[name='input_8']");
    let $utility = jQuery('#input_2_9');
    $paymentAssistance.change(function() {
        if (jQuery("input[name='input_8']:checked").val() == 'Utility Service') {
            // User selected BGE as their payment assistance need, set utility company to BGE and disable.
            $utility.val('0011R00001zkLfZQAU');
        }
    });
}

function scrollTo(element) {
    if ((jQuery(element) !== undefined) && (jQuery(element).offset() !== undefined)) {
        jQuery('html, body').animate({
            scrollTop: jQuery(element).offset().top
        }, 500);
    }
}

const inViewport = (entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            animateValue(entry.target, 0, entry.target.dataset.finalNumber, entry.target.dataset.duration);
        }
    });
};

function activateCounters() {
    let counters = document.getElementsByClassName('number-holder');
    for (let i = 0; i < counters.length; i++) {
        const observer = new IntersectionObserver(inViewport);
        observer.observe(counters[i]);
    }
}

// slick init
function initSlickCarousel() {
    jQuery('.text-slider').slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        swipe: true,
        infinite: true,
        adaptiveHeight: true,
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev d-block"><i class="fa-solid fa-arrow-left"></i><span class="accessibility">Previous Slide</span></button>',
        nextArrow: '<button type="button" class="slick-next d-block"><i class="fa-solid fa-arrow-right"></i><span class="accessibility">Next Slide</span></button>',
        appendArrows: '.text-slider-arrows'
    });
    jQuery('.simple-image-slider').slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        swipe: true,
        infinite: true,
        adaptiveHeight: true,
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev d-block"><i class="fa-solid fa-arrow-left"></i><span class="accessibility">Previous Slide</span></button>',
        nextArrow: '<button type="button" class="slick-next d-block"><i class="fa-solid fa-arrow-right"></i><span class="accessibility">Next Slide</span></button>',
        appendArrows: '.image-slider-arrows',
        responsive: [
            {
                breakpoint: 768,
                settings: "unslick"
            }
        ]
    });
}
